import React from 'react';

const NotFound = () => {

    return (
        <div className="not-found-container">
            <img src="/spekitOctopus.png"/>
            <h4>404 - Page Not Found</h4>
            <p><em>nothing to see here but a friendly octopus</em></p>
        </div>
    );
}

export default NotFound;
